import React, { useEffect, useState } from "react";
import { Backdrop, 
    CircularProgress, 
    Box, 
    Tabs, 
    Tab, 
    } from "@mui/material";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { ServiceApi } from "../../services/index.service";
import CreativeDialog from "./CreativeDialog";
import MandatoryPromotions from "./CreativesMandatoryPromotions";
import NonMandatoryPromotions from "./CreativesNonMandatoryPromotions";
import { useSelector } from "react-redux";
import { TabPanel } from "../BoardAdminstration";

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CreativesList = (props) => {
    const { operation, showCreativeDialog, setCreativeShowDialog } = props;
    const { enqueueSnackbar } = useSnackbar();
    // const [itemList, setItemList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [btnloading, setBtnLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [mandatoryList, setMandatoryList] = useState([]);
    const [nonMandatoryList, setNonMandatoryList] = useState([]);
    const serviceapi = new ServiceApi();
    const initialCreative = {
        intCreativeID: 0,
        vchCreativeName: "",
        bitActive: 0,
        bitMandatory: 0,
        bitRequired: 0,
        vchImageURL1: '',
        vchImageURL2: '',
        vchImageURL3: '',
        dteStartDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteEndDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        dteDateCreated: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    };
    const [selectedCreative, setSelectedCreative] = useState(initialCreative)
    const [displayDialog, setDisplayDialog] = useState(showCreativeDialog);
    const [action, setAction] = useState(operation)
    const [success, setSuccess] = useState(false)
    // const [selectedPromotion, setSelectedPromotion] = useState(initialCreative);
    const data = useSelector((state) => state);

    useEffect(() => {
        fetchCreativesList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [success]);

    const fetchCreativesList = async () => {
        const req = {
          role: data?.profile?.role,
          user_name: data?.profile?.user_name,
          bitBannerType: 1,
        };
        setLoading(true);
        const res = await serviceapi.fetchCreatives(req);
        setLoading(false);
        const result = res?.data;
        const resultsData = result?.data;
        setMandatoryList(resultsData?.mandatory);
        setNonMandatoryList(resultsData?.nonMandatory);
    };

    useEffect(() => {
        setDisplayDialog(showCreativeDialog)
    }, [showCreativeDialog])

    const tabsList = [
        {
          id: 1,
          title: "Mandatory",
          label: "Default",
          disabled: false,
        },
        {
          id: 2,
          label: "Optional",
          title: "Non-Mandatory",
          disabled: false,
        },
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
      };

    const handleDelete = async (dataItem) => {
        let req = {
            intCreativeID: dataItem?.intCreativeID,
            action: 'delete',
            vchCreativeName: dataItem?.vchCreativeName,
            vchImageURL1: dataItem?.vchImageURL1,
            vchImageURL2: dataItem?.vchImageURL2,
            vchImageURL3: dataItem?.vchImageURL3,
            dteStartDate: dataItem?.dteStartDate,
            dteEndDate: dataItem?.dteEndDate,
        };
        setBtnLoading(true);
        const res = await serviceapi.actionOnCreative(req);
        setBtnLoading(false);
        if (res?.success) {
            const message = "Creative Deleted Successfully";
            setSelectedCreative(initialCreative);
            enqueueSnackbar(message, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "success",
            });
            fetchCreativesList();
        } else {
            const message = "Error in Deleting Creative";
            enqueueSnackbar(message, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "error",
            });
        }
    };

    const handleEdit = async (dataItem) => {
        setAction("Update");
        setSelectedCreative(dataItem);
        setDisplayDialog(true);
    };

    const handleCloseCreativeDialog = () => {
        setDisplayDialog(false);
        setSelectedCreative(initialCreative)
        setAction("Add");
        setCreativeShowDialog(false)
    }
    
    const handleCreative = (value, name) => {
        setSelectedCreative({ ...selectedCreative, [name]: value });
    }

    const onCreativeSubmit = async () => {
        let req = {
            ...selectedCreative,
            vchCreativeName: selectedCreative?.vchCreativeName,
            vchImageURL1: selectedCreative?.vchImageURL1,
            vchImageURL2: selectedCreative?.vchImageURL2,
            vchImageURL3: selectedCreative?.vchImageURL3,
            bitActive: selectedCreative?.bitActive ? 1 : 0,
            dteStartDate: dayjs(selectedCreative?.dteStartDate).format('YYYY-MM-DD HH:mm:ss'),
            dteEndDate: dayjs(selectedCreative?.dteEndDate).format('YYYY-MM-DD HH:mm:ss')
        };
        setBtnLoading(true);
        if (action === "Add") {
            req = { ...req, intCreativeID: 0 };
        } else {
            req = { ...req, action: 'update' };
        }
        setSuccess(false)
        const res = await serviceapi.actionOnCreative(req);
        setBtnLoading(false);
        setAction("Add");
        setCreativeShowDialog(false)
        if (res?.success) {
            let message = "Creative Added Successfully";
            if (action === "Update") {
                message = "Creative Updated Successfully";
            }
            setSuccess(true)
            setDisplayDialog(false);
            setSelectedCreative(initialCreative);
            enqueueSnackbar(message, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "success",
            });
        } else {
            let message = "Error in Adding Creative";
            if (action === "Update") {
                message = "Error in Updating Creative";
            }
            enqueueSnackbar(message, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "error",
            });
        }
    }

    return (
        <>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading || btnloading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <main>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={value} onChange={handleChange}>
                    {tabsList?.map((itm, index) => (
                    <Tab
                        label={itm.label}
                        {...a11yProps(itm.id)}
                        key={itm.id}
                        disabled={itm.disabled}
                    />
                    ))}
                </Tabs>
                </Box>
                {tabsList?.map((tabItem, index) => {
                return (
                    <TabPanel key={tabItem.id} value={value} index={index}>
                    {tabItem.id === 1 && (
                        <MandatoryPromotions
                        loading={loading}
                        IsAdmin={true}
                        handleDelete={handleDelete}
                        handleEdit={handleEdit}
                        promotionsList={mandatoryList}
                        />
                    )}
                    {tabItem.id === 2 && (
                        <NonMandatoryPromotions
                        loading={loading}
                        handleDelete={handleDelete}
                        handleEdit={handleEdit}
                        IsAdmin={true}
                        promotionsList={nonMandatoryList}
                        />
                    )}
                    </TabPanel>
                );
                })}
            </main>
            {displayDialog ? (
                <CreativeDialog
                    displayDialog={displayDialog}
                    handleCloseCreativeDialog={handleCloseCreativeDialog}
                    action={action}
                    IsAdmin={true}
                    selectedCreative={selectedCreative}
                    handleCreative={handleCreative}
                    btnloading={btnloading}
                    onCreativeSubmit={onCreativeSubmit}
                    setSelectedCreative={setSelectedCreative} />
            ) : null}
        </>
        
    );
};

export default CreativesList;